import { gql } from '@apollo/client';

export const GET_RANKINGS_LIST = gql`
  query Ranklists($ranklistFilter: RankListFilterInput) {
    ranklists(ranklistFilter: $ranklistFilter) {
      id
      publishDate
      matchFormat
      listType
      itemCount
    }
  }
`;

export const GET_RANKING_LIST = gql`
  query Ranklist($id: String!, $itemPageArgs: PaginationArgs) {
    ranklist(id: $id) {
      id
      itemCount
      playerType
      publishDate
      matchFormatType
      rankingItems(itemPageArgs: $itemPageArgs) {
        id
        participants {
          itemId
          name
        }
        rank
      }
    }
  }
`;

export const GET_PT_POINTS = gql`
  query getProfiles($personIds: [PersonIDInput]) {
    activityProfiles(filter: { personIds: $personIds }) {
      items {
        person {
          username
        }
        ballColour
        points {
          ballColour
          doublesWinPoints
          singlesWinPoints
          totalPoints
          playPoints
        }
      }
    }
  }
`;
